import React, { useState } from "react";
import moment from "moment/moment";
import { Input } from "components/bootstrap";
const TimeBasedRotationStrategyConfiguration = ({
  config,
  updateConfig,
  disabled = false
}) => {
  const { max_rotation_period } = config;
  const [rotationPeriod, setRotationPeriod] = useState(config.rotation_period);
  const [rotateEmptyIndexSet, setRotateEmptyIndexSet] = useState(config.rotate_empty_index_set);
  const validationLimit = (durationInMilliseconds) => durationInMilliseconds <= moment.duration(max_rotation_period).asMilliseconds();
  const isValidPeriod = (duration) => {
    const check = duration || rotationPeriod;
    const checkInMilliseconds = moment.duration(check).asMilliseconds();
    return checkInMilliseconds >= 36e5 && (max_rotation_period ? validationLimit(checkInMilliseconds) : true);
  };
  const validationState = () => {
    if (isValidPeriod()) {
      return void 0;
    }
    return "error";
  };
  const formatDuration = () => {
    const maxRotationPeriodErrorMessage = max_rotation_period ? ` and max ${moment.duration(max_rotation_period).humanize()}` : "";
    return isValidPeriod() ? moment.duration(rotationPeriod).humanize() : `invalid (min 1 hour${maxRotationPeriodErrorMessage})`;
  };
  const handlePeriodUpdate = (e) => {
    let period = e.target.value.toUpperCase();
    if (!period.startsWith("P")) period = `P${period}`;
    setRotationPeriod(period);
    if (isValidPeriod(period)) {
      updateConfig({
        ...config,
        rotation_period: period
      });
    }
  };
  const handleRotateEmptyIndexSetUpdate = (e) => {
    setRotateEmptyIndexSet(e.target.checked);
    updateConfig({
      ...config,
      rotate_empty_index_set: e.target.checked
    });
  };
  return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(
    Input,
    {
      disabled,
      id: "rotation-period",
      type: "text",
      label: "Rotation period (ISO8601 Duration)",
      value: rotationPeriod,
      onChange: handlePeriodUpdate,
      help: `How long an index gets written to before it is rotated. (i.e. "P1D" for 1 day, "PT6H" for 6 hours).${max_rotation_period ? ` The max rotation period is set to ${moment.duration(max_rotation_period).humanize()} by Administrator.` : ""}`,
      addonAfter: formatDuration(),
      bsStyle: validationState(),
      required: true
    }
  ), /* @__PURE__ */ React.createElement(
    Input,
    {
      disabled,
      id: "rotate-empty-index-sets-checkbox",
      type: "checkbox",
      label: "Rotate empty index set",
      onChange: handleRotateEmptyIndexSetUpdate,
      checked: rotateEmptyIndexSet,
      help: "Apply the rotation strategy even when the index set is empty (not recommended)."
    }
  ));
};
export default TimeBasedRotationStrategyConfiguration;
